import { useCallback, useMemo, useState } from 'react';
import { useWindowWidth } from '@elfsight/lib-utils';
import { MIN_DEVICES_WIDTH } from '../constants';
import { getBreakpointsValues } from './getBreakpointsValues';

export const useColumns = (columnsValues: { [key: string]: number }) => {
  const [autoColumns, setAutoColumns] = useState<number>(1);
  const [customColumns, setCustomColumns] = useState<number>(1);
  const windowWidth = useWindowWidth();

  const breakpointsOptions = useMemo(
    () => ({
      [MIN_DEVICES_WIDTH.DESKTOP_LARGE]: columnsValues.columnsDesktopLarge,
      [MIN_DEVICES_WIDTH.DESKTOP_MEDIUM]: columnsValues.columnsDesktopMedium,
      [MIN_DEVICES_WIDTH.DESKTOP_SMALL]: columnsValues.columnsDesktopSmall,
      [MIN_DEVICES_WIDTH.TABLET]: columnsValues.columnsTablet,
      [MIN_DEVICES_WIDTH.MOBILE]: columnsValues.columnsMobile
    }),
    [
      columnsValues.columnsDesktopLarge,
      columnsValues.columnsDesktopMedium,
      columnsValues.columnsDesktopSmall,
      columnsValues.columnsTablet,
      columnsValues.columnsMobile
    ]
  );

  const handleEffectiveColumnsChange = useCallback((columnsCount: number) => {
    setAutoColumns(columnsCount);
  }, []);

  const recalculateColumns = useCallback(() => {
    const columnsCount = getBreakpointsValues(windowWidth, breakpointsOptions);
    setCustomColumns(columnsCount);
  }, [windowWidth, breakpointsOptions]);

  return {
    recalculateColumns,
    autoColumns,
    customColumns,
    windowWidth,
    handleEffectiveColumnsChange
  };
};
